module.exports = __webpack_public_path__ + "static/media/uml.52048e84.svg";